if (!customElements.get('dbtfy-testimonials')) {
  class DbtfyTestimonials extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const testimonialMediaElements = this.querySelectorAll('.dbtfy-testimonial__media[data-autoplay="false"]');

      testimonialMediaElements.forEach((video) => {
        const mediaContainer = video.querySelector('.dbtfy-testimonial__video');
        if (!mediaContainer) return;

        mediaContainer.addEventListener('click', () => {
          const videoEl = mediaContainer.querySelector('video');
          const poster = mediaContainer.querySelector('.video-section__poster');

          if (videoEl.paused) {
            videoEl.play();
            if (poster) poster.classList.add('hidden');
          } else {
            videoEl.pause();
            if (poster) poster.classList.remove('hidden');
          }
        });
      });
    }
  }

  class DbtfyTestimonialsCard extends DbtfyTestimonials {}

  customElements.define('dbtfy-testimonials', DbtfyTestimonials);

  if (!customElements.get('dbtfy-testimonials-card')) {
    customElements.define('dbtfy-testimonials-card', DbtfyTestimonialsCard);
  }
}
